import { HttpService } from './http-base.service';

export default class AuthService extends HttpService {
  constructor(baseURL) {
    if (!AuthService.instance) {
      super(baseURL);
      AuthService.instance = this;
    }

    return AuthService.instance;
  }

  login(data) {
    return this.post('/auth/local', data)
      .then((response) => response)
      .catch((err) => {
        throw err;
      });
  }

  googleAuth(idToken) {
    return this.post('/auth/google', { idToken })
      .then((response) => response)
      .catch((err) => {
        throw err;
      });
  }

  startFacebookMigration(data = {}) {
    return this.post('/auth/facebook/migration/start', data)
      .then((response) => response)
      .catch((err) => {
        throw err;
      });
  }

  completeFacebookMigrationWithGoogle(flow, idToken) {
    return this.post('/auth/facebook/migration/google', { flow, idToken })
      .then((response) => response)
      .catch((err) => {
        throw err;
      });
  }

  completeFacebookMigrationWithPassword(data) {
    return this.post('/auth/facebook/migration/password', data)
      .then((response) => response)
      .catch((err) => {
        throw err;
      });
  }

  logout() {
    return this.get('/auth/logout')
      .then((response) => response)
      .catch((err) => {
        throw err;
      });
  }
}
